import { themeConstants } from '@paywithextend/components'
import {
  base_colorContentBorder,
  text_colorTextPrimary,
  white100,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { transition_slower } from 'ext-ui/style/transitionSpeeds'
import {
  font_family_weight_medium,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import {
  sidenavBorderWidth,
  sidenavCollapsedWidth,
  sidenavExpandedWidth,
} from 'src/components/SidenavWrapper/sidenav.constants'
import { SlideLeft, SlideRight } from 'src/style/keyframeUtils'
import { css } from 'styled-components'

export const sidenavContentContainer = (fixedElementPushdown = 0) => css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  left: 0;
  background-color: ${white100};
  border-right: 1px solid ${base_colorContentBorder};
  pointer-events: none;
  overflow-x: hidden;
  width: auto;

  top: ${fixedElementPushdown}px;
  height: calc(100vh - ${fixedElementPushdown}px);

  &.first {
    max-width: ${sidenavCollapsedWidth}px;
  }
  &.firstToSecond {
    ${SlideRight(sidenavCollapsedWidth, sidenavExpandedWidth)}
  }
  &.second {
    max-width: ${sidenavExpandedWidth}px;
    pointer-events: all;
  }
  &.secondToFirst {
    ${SlideLeft(sidenavExpandedWidth, sidenavCollapsedWidth)}
  }
`

export const sidenavHeaderContent = css`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
  height: ${spacing(18)};
  width: 100%;
  justify-content: space-between;
  align-self: stretch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-bottom: 1px solid ${base_colorContentBorder};

  transition: padding ${transition_slower} ease-out;
  padding: ${spacing(6)} ${spacing(2)};
  &.open {
    padding: ${spacing(6)} ${spacing(5)};
  }
`

export const sidenavOrgIcon = css`
  background-color: ${themeConstants.colors.highlight};
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${spacing(6)};
  min-width: ${spacing(6)};
  border-radius: ${spacing(1)};
  cursor: pointer;

  ${font_sm};
  color: ${white100};
  font-family: ${font_family_weight_medium};
  text-transform: uppercase;
`

export const sidenavOrgName = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex-grow: 1;

  ${font_md};
  color: ${text_colorTextPrimary};
  font-family: ${font_family_weight_medium};
`

export const sidenavBody = css`
  width: ${sidenavExpandedWidth - sidenavBorderWidth}px;
  flex-grow: 1;
`
